export default {
  aboutProject: {
    title1: {
      en: "Project",
      pt: "Projeto",
    },
    title2: {
      en: "",
      pt: "",
    },
    description: {
      en:
        "LFAweb has a lot of functionalities about grammar and machine. " +
        "The platform is intended to assistant computer science students (and related) " +
        "to pratice knowledge involvin grammars and machines.",
      pt:
        "LFAweb possui uma série de funcionalidades relacionadas a gramáticas e a máquinas. A " +
        "plataforma tem como o intuito de auxiliar alunos do curso de ciência da computação (e " +
        "relacionados) a praticar conhecimentos envolvendo gramáticas e máquinas.",
    },
  },
  functionalities: {
    title1: {
      en: "Functionalities",
      pt: "Funcionalidades",
    },
    title2: {
      en: "",
      pt: "",
    },
    grammar: {
      title: {
        en: "Grammar",
        pt: "Gramática",
      },
      items: {
        validateGrammar: {
          en: "Grammar manipulate",
          pt: "Manipular gramáticas",
        },
        GR: {
          en: "Regular Grammar (RG)",
          pt: "Gramática Regular (GR)",
        },
        GLC: {
          en: "Context Free Grammar (CFG)",
          pt: "Gramática Livre de Contexto (GLC)",
        },
        GSC: {
          en: "Context Sensitive Grammar (CSG)",
          pt: "Gramática Sensível ao Contexto (GSC)",
        },
        GI: {
          en: "Unrestricted Grammar (UG)",
          pt: "Gramática Irrestrita (GI)",
        },
        Chomsky: {
          en: "CFG to Chomsky Normal Form",
          pt: "Colocar GLC na Forma Normal de Chomsky (FNC)",
        },
        Greibach: {
          en: "CFG to Greibach Normal Form",
          pt: "Colocar GLC na Forma Normal de Greibach (FNG)",
        },
        PushDown: {
          en: "Transform CFG to Push Down Automata",
          pt: "Converter GLC em Autômato com Pilha (AP)",
        },
        CYK: {
          en: "Cocke-Youger-Kasami Algorithm (CYK)",
          pt: "Verificar aceitação de palavras usando Cocke-Younger-Kasami (CYK)",
        },
      },
    },
    machine: {
      title: {
        en: "Machine",
        pt: "Máquina",
      },
      items: {
        drawAutomata: {
          en: "Draw automata",
          pt: "Desenhar autômato",
        },
        AFNDLambda: {
          en: "Non Deterministic Finite Automata with λ transitions (NDFA-λ)",
          pt: "Autômato Finito Não Determinístico com transições λ (AFND-λ)",
        },
        AFND: {
          en: "Non Deterministic Finite Automata (NDFA)",
          pt: "Autômato Finito Não Determinístico (AFND)",
        },
        AFD: {
          en: "Finite State Automata (FSA)",
          pt: "Autômato Finito Determinístico (AFD)",
        },
        convertionAFNDLambda: {
          en: "Convert AFND-λ → AFD",
          pt: "Converter AFND-λ em AFD",
        },

        complete: {
          en: "Complete automata",
          pt: "Completar autômato",
        },
        minimize: {
          en: "Minimize automata",
          pt: "Minimizar autômato",
        },
        regex: {
          en: "Convert regex expression to NDFA-λ ",
          pt: "Converter expressão regular em AFND-λ",
        },
        simulate: {
          en: "Check words acceptance",
          pt: "Verificar aceitação de palavras",
        },
      },
    },
  },
  team: {
    title1: {
      en: "Team",
      pt: "Equipe",
    },
    title2: {
      en: "",
      pt: "",
    },
    about: {
      en:
        "The LFAweb project is led by Teacher Ricardo Terra (DCC/UFLA) " +
        "The following undergraduate students bring (or have already brought) several " +
        "contribution to the project.",
      pt:
        "O projeto LFAweb é liderado pelo Prof. Ricardo Terra (DCC/UFLA)." +
        "Os seguintes alunos de iniciação científica trazem (ou já trouxeram) diversas " +
        "contribuições para o projeto:",
    },
    function: {
      developer: {
        en: "Developer",
        pt: "Desenvolvedor",
      },
      academicAdvisor: {
        en: "Academic Advisor",
        pt: "Orientador",
      },
    },
  },
};
